<div class="m-3" lohiPageTitle="Internal">
  <div class="flex justify-between">
    <div class="flex-1">
      <lohi-company-switcher class="w-full"></lohi-company-switcher>
    </div>
    <div class="flex-1 flex items-center justify-end">
      <a class="text-blue-500 text-xl underline" routerLink="../shift_inspector"
        >Looking for the Shift Inspector/Map? -></a
      >
    </div>
  </div>
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-1">
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../shift_inspector">Shift Inspector/Map</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../revenue_allocation">Revenue Allocation Dashboard</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../auto_dispatch_stats">Auto Dispatch Stats</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../capacity_management">Capacity Management</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../honey_map">Honey Map</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../shift_tool">Shift Predictor</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../company_trailers">Company Trailers</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../all_trailers">All Trailers</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../dispatch">Dispatch</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../create-demand-snapshot">Create Demand Snapshots</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../lane-tool">Lane Import</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../demand_import">Order Demand Import</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../demand_import/supply">Driver Supply Import</a>
    </div>
    <a class="text-white text-2xl bg-blue-500 rounded p-2 text-center" routerLink="../supply_forecast"
      >Supply Forecast</a
    >
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../lohi_loop">LoHi Loop</a>
    </div>
    <a class="text-white text-2xl bg-blue-500 rounded p-2 text-center" routerLink="../regional_dashboard"
      >Regional Dashboard</a
    >
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../ops_billing">Operational Billing</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../tour_dashboard">5F Tour Dashboard</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../omma">OMMA</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../bolocr/list">BOL OCR</a>
    </div>
    <div>
      <a class="text-blue-500 text-xl underline" routerLink="../shift_daily_cap">Shift Daily Cap</a>
    </div>
  </div>
  <div>
    <div class="text-2xl font-bold">Company Trailer Information</div>
    <lohi-company-trailers></lohi-company-trailers>
  </div>
  <!--<div>
    <lohi-internal-shift-graph></lohi-internal-shift-graph>
  </div>-->
</div>
